export default "__VITE_ASSET__bef3884c__"